import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Link } from '@mui/material';

export default function EntityProperties({ entity, model }) {
  const values = entity?.values || {};
  const fields = [...(model?.fields || [])].sort(
    (a, b) => (a.order ?? 0) - (b.order ?? 0)
  );
  const fieldKeys = new Set(fields.map(field => field.key));
  const properties = [
    ...fields,
    ...Object.keys(values)
      .filter(key => !fieldKeys.has(key))
      .map(key => ({ key, label: key })),
  ];

  const formatValue = value => {
    if (value === null || value === undefined || value === '') return '—';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2">Entity properties</Typography>
      {entity ? (
        <>
          <Typography variant="body2" color="text.secondary">
            {entity.entity_model_name || model?.name}
          </Typography>
          {entity.monitor_group && (
            <Box sx={{ my: 2 }}>
              <Typography variant="subtitle2">Monitor group</Typography>
              <Link
                component={RouterLink}
                to={`/monitor-groups?group=${entity.monitor_group.id}&organization=${entity.monitor_group.organization}`}
              >
                {entity.monitor_group.name}
              </Link>
              <Typography variant="body2">
                Role:{' '}
                {entity.monitor_group.role === 'master'
                  ? 'Master'
                  : 'Secondary'}
              </Typography>
              <Typography variant="body2">
                Assigned star: {entity.monitor_group.assigned_star.name}
              </Typography>
            </Box>
          )}
          {properties.length ? (
            <Box component="dl" sx={{ my: 1, fontSize: '0.875rem' }}>
              {properties.map(field => (
                <Box key={field.key} sx={{ mb: 1, overflowWrap: 'anywhere' }}>
                  <Box component="dt" sx={{ fontWeight: 600 }}>
                    {field.label || field.key}
                  </Box>
                  <Box component="dd" sx={{ m: 0, whiteSpace: 'pre-wrap' }}>
                    {formatValue(values[field.key])}
                  </Box>
                </Box>
              ))}
            </Box>
          ) : (
            <Typography variant="body2">No properties defined.</Typography>
          )}
        </>
      ) : (
        <Typography variant="body2">No entity attached to this pin.</Typography>
      )}
    </Box>
  );
}
